import { ApplicationElement, html } from '@effectivastudio/lit-components';
import DateWidget from '@effectivastudio/lit-components/components/date_widget/element.js';

import style from './style.lit.css';

/**
 * Presents date widget with day and month info.
 *
 * NOTES:
 *
 * - demo style of the component is general, see other examples for use in XS-CARD and XS-CARD-ITEM-2
 * - examples are for layout only, additional style may be applied in the component Date widget is used in
 * - class "block" for use in XS-CARD
 * - class "inline" for use in XS-CARD-ITEM-2
 *
 * @prop date - Full date, prop from Lit (options: Date, Date string, timestamp)
 * @prop layout - For use in different components (options: inline, block)
 * @prop dayNameOn - Should show day name? (optional)
 *
 * @cssprop --font-weight - Number font weight
 * @cssprop --text-transform - Month text capitalization
 * @cssprop --day-font-size - Day font size
 * @cssprop --month-font-size - Month font size
 */

export default class DateWidgetExtended extends DateWidget {
  static styles = [ApplicationElement.styles, style];

  static properties = {
    layout: { type: String, reflect: true },
    dayNameOn: { type: Boolean, reflect: true },
  };

  constructor() {
    super();
    this.layout = 'block';
  }

  renderDayName() {
    return html`<div class="day-name">${this.dayName}</div>`;
  }

  render() {
    return html`
      ${this.dayNameOn ? this.renderDayName() : null}
      <div class="day">${this.day}</div>
      <div class="month">${this.monthName}</div>
    `;
  }
}

customElements.get('xs-card-date-widget') ||
  customElements.define('xs-card-date-widget', DateWidgetExtended);
